
<div class="card-body">
  <div class="clinic-logo">
    <img [src]="getLogoUrl()" 
     (error)="onImgError($event)" 
     alt="Clinic Logo">
    <h2 class="clinic-name">{{ clinicInfo.displayName }}</h2>
  </div>  
  
  <div class="clinic-details">
    <div class="clinic-action" (click)="navigateToClinic()">
      <mat-icon>location_on</mat-icon>
      <div class="action-content">
        <div class="action-label">Address</div>
        <div class="action-text">{{ clinicInfo.address }}</div>
      </div>
    </div>
    
    <div class="clinic-action" (click)="callClinic()">
      <mat-icon>phone</mat-icon>
      <div class="action-content">
        <div class="action-label">Phone</div>
        <div class="action-text">{{ clinicInfo.phoneNumber }}</div>
      </div>
    </div>
    
    <div class="clinic-action" *ngIf="clinicInfo.email">
      <mat-icon>email</mat-icon>
      <div class="action-content">
        <div class="action-label">Email</div>
        <div class="action-text">{{ clinicInfo.email }}</div>
      </div>
    </div>
  </div>
</div>